import React, { Fragment, useState } from 'react';

import Image from 'next/image';

import { Text } from '@BICE_Vida/components';

import { landingText } from '@/utils/generalTexts';

import styles from './Hero.module.scss';
import PreexistingConditionsModal from '@/components/PreexistingConditionsHeader/PreexistingConditionsModal';
import TelemedicineModal from './TelemedicineModal';
import { trackClick, clickActionsEvents } from '@/utils/dataLayer/home';

const Features = ({ availablePlans }: { availablePlans: number }) => {
  const [openModal, setOpenModal] = useState<'preexisting' | 'telemedicine' | null>(null);

  const handleOpenModal = (modalType: 'preexisting' | 'telemedicine') => {
    setOpenModal(modalType);
    if (modalType === 'preexisting') {
      trackClick({ action: clickActionsEvents.btnPreexistingConditions });
    }
  };

  const handleCloseModal = () => {
    setOpenModal(null);
  };

  return (
    <Fragment>
      <PreexistingConditionsModal
        isOpen={openModal === 'preexisting'}
        setIsOpen={handleCloseModal}
        availablePlans={availablePlans}
      />
      <TelemedicineModal isOpen={openModal === 'telemedicine'} setIsOpen={handleCloseModal} />
      <div className={styles.features_cards_row_hero_container}>
        <div className={styles.features_cards_row_hero}>
          {landingText.features.cards.map((card, index: number) => (
            <div className={styles.features_card_hero} key={index}>
              <div className={styles.features_card_icon}>
                <Image src={card.icon} alt={card.alt} width={64} height={64} />
              </div>
              <div className={styles.features_card_texts_hero}>
                <Text className={styles.features_card_title_hero}>{card.title}</Text>
                <Text className={styles.features_card_paragraph_hero}>
                  {card.paragraph(() =>
                    card.modal === 'preexisting' || card.modal === 'telemedicine'
                      ? handleOpenModal(card.modal)
                      : undefined
                  )}
                </Text>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Fragment>
  );
};

export default Features;
